const base=(import.meta.env.VITE_API_BASE_URL||'').replace(/\/$/,'');
export async function fetchWorksheetFile(endpoint:string,filename:string):Promise<File>{
  if(!/^\/api\/v1\/assets\/[0-9a-f-]{36}$/i.test(endpoint))throw new Error('Не удалось получить файл. Попробуйте снова.');
  const response=await fetch(base+endpoint,{credentials:'include',redirect:'error',headers:{Accept:'application/pdf'}});
  if(!response.ok)throw new Error(response.status===401?'Сессия закончилась. Откройте урок заново.':'Не удалось скачать файл. Попробуйте снова.');
  if(response.headers.get('content-type')?.split(';')[0]!=='application/pdf')throw new Error('Не удалось получить PDF. Попробуйте снова.');
  const blob=await response.blob();
  if(await blob.slice(0,5).text()!=='%PDF-')throw new Error('Не удалось получить PDF. Попробуйте снова.');
  return new File([blob],filename,{type:'application/pdf'});
}
export async function requestPdfDownloadTicket(endpoint:string):Promise<{url:string;fileName:string}>{
  if(!/^\/api\/v1\/assets\/[0-9a-f-]{36}$/i.test(endpoint))throw new Error('Не удалось получить ссылку для скачивания.');
  const response=await fetch(base+endpoint+'/download-ticket',{credentials:'include',redirect:'error',headers:{Accept:'application/json'}});
  if(!response.ok)throw new Error(response.status===401?'Сессия закончилась. Откройте урок заново.':'Не удалось подготовить скачивание.');
  const data=await response.json();
  if(typeof data?.url!=='string'||!new RegExp(`^${endpoint}/download\\?token=[0-9a-f.]+$`,'i').test(data.url)||typeof data?.fileName!=='string'||!/^[-\w.]+\.pdf$/i.test(data.fileName))throw new Error('Не удалось подготовить скачивание.');
  return {url:data.url,fileName:data.fileName};
}
export function saveWorksheetFile(file:File){
  const url=URL.createObjectURL(file),link=document.createElement('a');
  link.href=url;link.download=file.name;link.hidden=true;
  try{document.body.appendChild(link);link.click();}finally{
    link.remove();
    // WebViews may consume the Blob asynchronously after the click.
    window.setTimeout(()=>URL.revokeObjectURL(url),60_000);
  }
}
